import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/contexts/AuthContext";
import { theme } from "@/lib/theme";

export default function SubscriptionGate({ children }: { children: ReactNode }) {
    const location = useLocation();
    const { user, isLoading } = useAuth();

    if (isLoading) {
        return (
            <div className={`min-h-screen flex items-center justify-center ${theme.colors.backgroundCream} text-gray-900 dark:text-gray-100`}>
                <div className="flex flex-col items-center gap-3">
                    <div className={`w-12 h-12 border-4 border-gray-200 dark:border-gray-700 border-t-primary-orange dark:border-t-primary-orange-dark rounded-full animate-spin`} />
                    <p className="text-lg font-medium">Checking subscription...</p>
                </div>
            </div>
        );
    }

    // If not logged in, AuthGate should have caught this, but just in case:
    if (!user) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    if (user.subscription_status !== "active") {
        return <Navigate to="/paywall" replace state={{ from: location }} />;
    }

    return <>{children}</>;
}
